import React from "react";
import Header from "../components/header/Header";
import Product from "../components/product/Product";
import Category from "../components/category/Category";

const Home = () => {
  return (
    <div>
      <Header />
      <Product />
      <Category />
    </div>
  );
};

export default Home;
